import MediatorManager from "../../../core/application/MediatorManager";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import MapsConfig from "../model/MapsConfig";

export default class MapFactory {
    /**
     * @console
     * @param {MediatorManager} mediatorManager 
     * @param {MapsConfig} mapsConfig 
     */
    constructor(mediatorManager, mapsConfig) {
        this._mediatorManager = mediatorManager;
        this._mapsConfig = mapsConfig;
    }

    createMap(container, mapId) {
        const mapDefinition = this._mapsConfig.getMapById(mapId);
        const movieClipLinkage = mapDefinition.movieClipName;
        const mapSkinConstructor = lib.MainAssets[movieClipLinkage];
        if (!mapSkinConstructor) {
            console.error(`[MapFactory] Cannot create map, movie clip '${movieClipLinkage}' doesn't exists in MainAssets.`);
            return;
        }

        const mapSkin = new mapSkinConstructor();
        container.addChild(mapSkin);

        const mapMediator = this._mediatorManager.createMediator(mapSkin, SkinKeyRegistry.MAP_SKIN);
        return mapMediator;
    }
}